import classNames from 'classnames'

import { EntityProfileHeaderTextButton } from '../../EntityProfileHeaderTextButton'
import { EntityProfileHeaderTextBase } from '../EntityProfileHeaderTextBase'

import * as styles from '../EntityProfileHeaderText.module.css'

function EntityProfileHeaderTextPlain({
  EditButton = EntityProfileHeaderTextButton,
  additionalIcons,
  className = styles.editableRoot,
  editButtonQaName,
  isEditButtonHoverVisible,
  isLoading,
  onClickEditButton,
  ...restProps
}) {
  const titleGroupClassName = classNames(styles.titleGroup, {
    [styles.loading]: isLoading,
  })

  return (
    <div className={className}>
      <div className={titleGroupClassName}>
        <EntityProfileHeaderTextBase
          {...restProps}
          className={styles.textWrapper}
          isLoading={isLoading}
        />
        {isLoading ? null : additionalIcons}
        {EditButton && !isLoading ? (
          <EditButton
            className={classNames(styles.editButton, {
              [styles.editButtonHoverVisible]: isEditButtonHoverVisible,
            })}
            qaName={editButtonQaName}
            onClick={onClickEditButton}
          />
        ) : null}
      </div>
    </div>
  )
}

export default EntityProfileHeaderTextPlain
